import { addressBookPaginationStyles } from "@insite/content-library/Widgets/Addresses/AddressBookPagination";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import getColor from "@insite/mobius/utilities/getColor";
import { COLORS, TYPOGRAPHY } from "@tecumseh/theme/design";
import { css } from "styled-components";

addressBookPaginationStyles.pagination = {
    cssOverrides: {
        pagination: css`
            justify-content: center;
            background-color: ${COLORS.background.base};
            height: 30px;
            font-size: ${TYPOGRAPHY.size.smallest};
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        margin-bottom: 35px;
                    `,
                    css`
                        margin-bottom: 35px;
                    `,
                    css`
                        margin-bottom: 35px;
                    `,
                    null,
                    null,
                ])}
        `,
        perPageSelect: css`
            ${({ theme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            display: none;
                        `,
                        null,
                        null,
                        null,
                        null,
                    ],
                    "min",
                )}
        `,
        currentButton: css`
            min-height: 30px;
            background: ${getColor("primary")};
            border-radius: 0px;
            span {
                color: ${COLORS.white}!important;
            }
            &:hover {
                background: ${getColor("primary")};
            }
        `,
    },
    buttonProps: {
        mergeCss: true,
        css: css`
            border-radius: 0px;
            border: none;
            color: ${getColor("text.main")};
            [class^="TypographyStyle"] {
                color: inherit;
            }
            &:hover {
                background: ${COLORS.border.base};
            }
            &:active {
                background: ${COLORS.border.base};
            }
        `,
    },
};




